import axios from "axios"
import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"
import { RootState } from "../../store/store"

import { API_UPDATE_DEFAULT_BANK_REQUESTS_URL } from "../constants"
import { IGetUpdateDefaultBankRequestResponse } from "../interface"

async function get(
  token: string | null,
  requestId: string | null,
) {
  const response = await axios(`${API_UPDATE_DEFAULT_BANK_REQUESTS_URL}/${requestId}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  // TODO: обработка ошибок
  return response.data
}

export const useGetUpdateDefaultBankRequestStatus = (requestId: string, enablePolling: boolean) => {
  const token = useSelector((state: RootState) => state.auth.token)
  
  return useQuery<IGetUpdateDefaultBankRequestResponse>({
    queryKey: ["status-update-default-bank-request", requestId],
    queryFn: () => get(token, requestId),
    enabled: enablePolling,
    refetchInterval: 1000,
  })
}
